import { MenuItem } from '../../ui/dtos/menu-item';
import {
  faChartLine,
  faCreditCard,
  faPeopleGroup,
} from '@fortawesome/free-solid-svg-icons';
import { core } from '../../ui/side-nav/core-menu-items';
import { AdminUiSettings } from '../../common/dtos';

const defaultFinanceGroupId = '9f14d2d2-8b6f-4f12-9a6e-c9696d8a5f70';

export function getFinanceMenuItems(settings: AdminUiSettings): MenuItem[] {
  const menuItems = [
    {
      label: 'Finance Dashboard',
      url: `/main/financing/dashboard/${defaultFinanceGroupId}`,
      icon: faChartLine,
    },
    core.projectsMenuItem,
  ];
  if (settings.entities.canManageEntities) {
    menuItems.push(core.entitiesMenuItem);
  } else {
    menuItems.push({
      label: 'People',
      url: '/main/abc/people',
      icon: faPeopleGroup,
    });
  }

  if (settings.transactions.canManageTransactions) {
    menuItems.push({
      label: 'Transactions',
      url: '/main/accounts/transactions',
      icon: faCreditCard,
    });
  }

  if (settings.users.canManageUsers) {
    menuItems.push(core.usersMenuItem);
  }

  menuItems.push(core.auditMenuItem);

  return menuItems;
}
